import { clsx } from 'clsx';

export const getGridStyles = (hasTimezoneWarning: boolean) => {
  const baseClass = 'grid grid-cols-[min-content_auto] items-center gap-3';

  return clsx(baseClass, hasTimezoneWarning ? 'grid-rows-[min-content_auto]' : 'grid-rows-[min-content]');
};
